var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "admin" }, [
    _c(
      "div",
      { staticClass: "content" },
      [
        _c("FunBtn", {
          attrs: {
            funBtns: _vm.funBtns,
            defaultColumn: _vm.defaultColumn,
            isShowSelectChange: true,
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "admin-main" },
          [
            _c("ZhjyTable", {
              attrs: {
                minWidth: _vm.minWidth,
                tableData: _vm.tableData,
                columList: _vm.defaultColumn,
                isShowSelection: true,
                options: _vm.options,
                formatters: _vm.formatters,
                pageNum: _vm.page.pageNum,
                pageSize: _vm.page.pageSize,
              },
              on: {
                "update:pageNum": function ($event) {
                  return _vm.$set(_vm.page, "pageNum", $event)
                },
                "update:page-num": function ($event) {
                  return _vm.$set(_vm.page, "pageNum", $event)
                },
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }